import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { baseColors } from "@Constants/baseStyles"
import React from "react"
import { Dimensions, View } from "react-native"
import { ActivityIndicator } from "react-native-paper"
import { RFValue } from "react-native-responsive-fontsize"
const { height, width } = Dimensions.get("screen")
export const GlobalLoading = () => {
    return (
        <View
            style={{
                width: width,
                height: height,
                backgroundColor: baseColors.white,
                display: "flex",
                justifyContent: "center",
                alignContent: "center"
            }}
        >
            <ActivityIndicator color={baseColors.green.primary} size={"large"} />
            <View style={{ padding: 20 }}>
                <BreeSerifText textAlign={"center"} fontSize={RFValue(20)}>
                    Chargement en cours...
                </BreeSerifText>
            </View>
        </View>
    )
}
